import {
  Inject,
  Injectable,
  LOCALE_ID
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { CONSUMER_TYPE, CONSUMERS, ConsumerType } from '../domain/consumer-type.domain';
import { LinkRegistryService } from './link-registry.service';

// To match the backend definition and use it at the url
enum SITES {
  WB = 'wb',
  ET = 'et'
}

@Injectable({
  providedIn: 'root'
})
export class WiscService {

  constructor(private http: HttpClient,
              private linkRegistryService: LinkRegistryService,
              @Inject(LOCALE_ID) private locale: string,
              @Inject(CONSUMER_TYPE) private consumer: ConsumerType) {}

  cachedData: object = {};

  public getJsonData<Type>(name: string): Observable<Type> {
    const linkBase = this.linkRegistryService.getLink('link_json_base');
    const site = this.isWebbroker() ? SITES.WB : SITES.ET;
    const path = `${linkBase}/${site}/json/${this.locale}/${name}.json`;
    if (!this.cachedData[path]) {
      this.cachedData[path] = this.http.get<Type>(path).pipe(shareReplay(1));
    }
    return this.cachedData[path];
  }

  private isWebbroker(): boolean {
    return this.consumer.consumerId === CONSUMERS.CONSUMER_ID_WEB_BROKER;
  }
}

